import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
function Navbar() {
  const [showMobNav, setShowMobNav] = useState(false);
  const location = useLocation();
  const navigate = useNavigate()
  const navItem = [
    {
      name: "Home",
      icon: "fa fa-home",
      path: "/",
    },
    {
      name: "About",
      icon: "fa fa-info-circle",
      path: "/about",
    },
    {
      name: "Services",
      icon: "fa fa-cogs",
      path: "/services",
    },
    {
      name: "Portfolio",
      icon: "fa fa-laptop",
      path: "/portfolio",
    },
    {
      name: "Team",
      icon: "fa fa-users",
      path: "/team",
    },
    {
      name: "Contact Us",
      icon: "fa fa-phone",
      path: "/contact",
    },
  ];
  return (
    <>
      <header id="header" className="header d-flex align-items-center fixed-top " style={{ background: "#fff" }}>
        <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
          <Link to="/" className="logo d-flex p-1 px-2  rounded align-items-center">
            <img src="/assets/img/brandLogo.jpeg" alt className="rounded"  />
            <h2 className="d-flex align-items-center mb-0  " style={{color:"#002951", letterSpacing:"0px"}}>
              Soft Tech Gem
            </h2>
          </Link>
          <span className="d-md-none d-block border rounded px-1 shadow">
            <i
              className={"mobile-nav-toggle mobile-nav-show bi " + (!showMobNav ? " bi-list" : " bi-x")}
              onClick={() => setShowMobNav(!showMobNav)}
              style={{color:"#002951"}}
            />
          </span>

          <nav id="navbar" className="navbar">
            <ul>
              {navItem?.map((v, i) => {
                return (
                  <li>
                    <Link to={v?.path} style={{color:"#1B2F45"}} className={location.pathname == v?.path && " text-danger"}>
                      <i className={v?.icon + " me-2"}></i>
                      {v?.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </header>
      {showMobNav && (
        <div className="vh-100 d-block d-md-none" style={{ background: "#1B2F45" }}>
          <div className="vh-100 mobNavSlide" style={{ background: "#1B2F45" }}>
            <ul className="mt-5 pt-5">
              {navItem?.map((v, i) => {
                return (
                  <li style={{ listStyle: "none" }} className="mb-4">
                    <a onClick={()=>{setShowMobNav(false); navigate(v?.path)}} className={location.pathname == v?.path ? " text-light" : " text-secondary"}>
                      <i className={v?.icon + " me-2"}></i>
                      {v?.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
